export const IMAGE_LOGO_LIGHT: string = 'img/logo/TOTEM_logotype_white.svg';
export const IMAGE_LOGO_DARK: string = 'img/logo/TOTEM_logotype.svg';

export const IMAGE_LOGIN_BACKGROUND: string = 'web/img/multiple-columns-store.png';
